import { type UseQueryResult, useQuery } from 'react-query';
import { OptionAwardService } from '../../services/wealthlane-award-services';

const useGetOptionAwardNumber = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const optionAwardNumberOptions = useQuery(
    ['getOptionAwardNumberOptions', id],
    async () => {
      return await handleRequest(
        OptionAwardService.getApiAwardApiAppOptionAwardOptionAwardNumbers(id)
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.awardNumber ?? '',
            value: item.optionAwardId ?? '',
          };
        });
      },
    }
  );

  return optionAwardNumberOptions;
};

export default useGetOptionAwardNumber;
